import { FC } from 'react'
import classnames from 'classnames'

import './styles.scss'

interface EmptyStateProps {
  className?: string
  text?: string
  image?: {
    src: string
    description: string
  }
}

const EmptyState: FC<EmptyStateProps> = ({ className, text, image }) => {
  return (
    <div className={classnames('emptyState', className)}>
      {image && (
        <img
          src={image.src}
          alt={image.description}
          title={image.description}
        />
      )}
      {text && <span className="emptyState__text">{text}</span>}
    </div>
  )
}

export default EmptyState
